import { SORT_TYPE } from 'constants/common'
import { useTranslation } from 'react-i18next'
import * as UseStyled from 'features/report/useStyled'
import TableRowCommon from 'component/Table/TableRowCommon'
import { dateToView } from 'utils/date.utils'
import { Box, Typography } from '@mui/material'
import TableCustom from 'component/Table/TableCustom'
import { numberFormat } from 'utils/app.utils'
import _ from 'lodash'

interface IncomeExpenseListProps {
  page: number
  pageLimit: number
  rowCount: number
  data: any
  dataIncome: any[]
  dataExpense: any[]
  handleChangeRowsPerPage: (val: any) => void
  handleChangePage: (val: any) => void
  onRequestSort: (sortBy: string, sortType: string) => void
  setSortType: (val: SORT_TYPE) => void
  setSortBy: (val: string) => void
  sortType: string
  sortBy: string
}

const IncomeExpenseList = (props: IncomeExpenseListProps) => {
  const { t } = useTranslation()

  const { dataIncome, dataExpense } = props

  const onRequestSort = (sortByVal: string, sortTypeVal: SORT_TYPE) => {
    props.setSortType(sortTypeVal)
    props.setSortBy(sortByVal)
    props.handleChangePage(1)
  }

  const headCells = [
    { id: '1', disablePadding: false, labelKey: t('REPORT.TABLE.FOLLOW_UP.#'), align: 'center', class: 'text-nowrap', width: '30px', },
    { id: '3', disablePadding: false, labelKey: t('REPORT.TABLE.STOCK.DOCUMENT_NO'), align: 'left', class: 'text-nowrap', width: '150px', },
    { id: '4', disablePadding: false, labelKey: t('INCOME_EXPENSES.TABLE.CELL.HEADER.DOCUMENT_CREATION_DATE'), align: 'center', class: 'text-nowrap', width: '150px', },
    { id: '5', disablePadding: false, labelKey: t('REPORT.TABLE.SALE_SUMMARY_MONTH.TYPE'), align: 'left', class: 'text-nowrap', width: '200px', },
    { id: '6', disablePadding: false, labelKey: t("REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.LIST"), align: 'left', class: 'text-nowrap', width: '250px', },
    { id: '7', disablePadding: false, labelKey: t("REPORT.TABLE.COMMISSION.QTY"), align: 'right', class: 'text-nowrap', width: '10px', },
    { id: '8', disablePadding: false, labelKey: t("REPORT.TABLE.INCOME_EXPENSE.PRICEBAHT"), align: 'right', class: 'text-nowrap', width: '150px', },
    { id: '9', disablePadding: false, labelKey: t("REPORT.TABLE.INCOME_EXPENSE.TOTALBAHT"), align: 'center', class: 'text-nowrap', width: '150px', },
    { id: '10', disablePadding: false, labelKey: t('STATUS.LABEL'), align: 'center', class: 'text-nowrap', width: '120px' },
    { id: '11', disablePadding: false, labelKey: t("REPORT.TABLE.INCREASE.UPDATED_BY"), align: 'center', class: 'text-nowrap', },
  ]

  const renderData = (data: any, no: number) => {
    const num = props.page * props.pageLimit - props.pageLimit + no + 1

    const { documentNo, documentDate, expenseGroup, expenseTypeName, qty, price, status, updatedAt, updatedBy, total } = data

    const objRenderData = {
      key: num.toString(),
      id: no.toString(),
      obj: data,
      columns: [
        { option: 'TEXT', align: 'center', label: num, class: 'text-nowrap' },
        { option: 'TEXT', align: 'left', label: documentNo, class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: dateToView(documentDate), class: 'text-nowrap' },
        { option: 'TEXT', align: 'left', label: t(`INCOME_EXPENSES.TABLE.CELL.EXPENSE_GROUP.${expenseGroup}.TITLE`), class: 'text-nowrap' },
        { option: 'TEXT', align: 'left', label: expenseTypeName, class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', label: qty, class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', label: numberFormat(price), class: 'text-nowrap' },
        { option: 'TEXT', align: 'right', label: numberFormat(total), class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: t(`INCOME_EXPENSES.DOCUMENT_STATUS.${status}`), class: 'text-nowrap' },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt }, class: 'text-nowrap-ellipsis' },
      ]
    }

    return <TableRowCommon {...objRenderData} />
  }

  const headCellsSub = [
    { id: '1', disablePadding: false, labelKey: t('REPORT.TABLE.FOLLOW_UP.#'), align: 'center', class: 'text-nowrap', width: '30px', },
    { id: '6', disablePadding: false, labelKey: t("REPORT.TABLE.OPERATIVE_SUMMARY_MONTH.LIST"), align: 'left', class: 'text-nowrap', width: '250px', },
    { id: '7', disablePadding: false, labelKey: t("REPORT.TABLE.COMMISSION.QTY"), align: 'right', class: 'text-nowrap', width: '10px', },
    { id: '7', disablePadding: false, labelKey: t("REPORT.TABLE.INCOME_EXPENSE.PRICEBAHT"), align: 'right', class: 'text-nowrap', width: '150px', },
    { id: '7', disablePadding: false, labelKey: t("REPORT.TABLE.INCOME_EXPENSE.TOTALBAHT"), align: 'center', class: 'text-nowrap', width: '150px', },
  ]

  const renderDataIncomeExpense = (data: any, no: number, render: 'data' | 'sum') => {
    const { expenseTypeName, qty, price, total } = data
    if (render === 'data') {
      const objRenderData = {
        key: (no + 1).toString(),
        id: no.toString(),
        obj: data,
        columns: [
          { option: 'TEXT', align: 'center', label: no + 1, class: 'text-nowrap' },
          { option: 'TEXT', align: 'left', label: expenseTypeName, class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', label: qty, class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', label: numberFormat(price), class: 'text-nowrap' },
          { option: 'TEXT', align: 'right', label: numberFormat(total), class: 'text-nowrap' },
        ]
      }

      return <TableRowCommon {...objRenderData} />
    }
    const objRenderData = {
      key: no.toString(),
      id: no.toString(),
      obj: data,
      columns: [
        { option: 'MERGE', align: 'center', colSpan: 3, class: 'col-merge' },
        {
          option: 'TEXT',
          align: 'right',
          label: <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>{t('REPORT.TITLE.SUM')}</Typography>,
          class: 'text-nowrap col-sum'
        },
        { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'total') || 0), class: 'text-nowrap' },
      ],
      classes: 'row-summary'
    }
    return <TableRowCommon {...objRenderData} />
  }

  return (
    <>
      <Box>
        <UseStyled.ResponsiveReportTable>
          <TableCustom
            rowHeadCell={2}
            // tableMinWidth={992}
            page={props.page}
            pageLimit={props.pageLimit}
            sortType={props.sortType}
            sortBy={props.sortBy}
            rowCount={props.rowCount}
            onSort={onRequestSort}
            setPageLimit={props.handleChangeRowsPerPage}
            setPage={props.handleChangePage}
            headCells={headCells}
            rowsData={props.data?.length ? [
              _.map(props.data, (d: any, index: number) => {
                return renderData(d, index)
              }),
            ] : []}
            customScroll
          />
        </UseStyled.ResponsiveReportTable>
      </Box>
      <Box marginTop='32px'>
        <Typography fontSize={'20px'} marginBottom={'16px'} fontWeight={500}>
          {t('REPORT.TABLE.INCOME_EXPENSE.SUM_INCOME')}
        </Typography>
        <Box maxWidth='900px' sx={!dataIncome?.length ? { tr: { td: { textAlign: 'center' } } } : {}}>
          <UseStyled.ResponsiveReportTable>
            <TableCustom
              rowHeadCell={2}
              page={props.page}
              pageLimit={props.pageLimit}
              sortType={props.sortType}
              sortBy={props.sortBy}
              rowCount={props.rowCount}
              onSort={onRequestSort}
              setPageLimit={props.handleChangeRowsPerPage}
              setPage={props.handleChangePage}
              headCells={headCellsSub}
              rowsData={
                dataIncome?.length ? [
                  _.map(dataIncome, (d: any, index: number) => {
                    return renderDataIncomeExpense(d, index, 'data')
                  }),
                  renderDataIncomeExpense(dataIncome, 0, 'sum')
                ] : []}
              customScroll
              hidePagination
            />
          </UseStyled.ResponsiveReportTable>
        </Box>
      </Box>

      <Box marginTop='32px'>
        <Typography fontSize={'20px'} marginBottom={'16px'} fontWeight={500}>
          {t('REPORT.TABLE.INCOME_EXPENSE.SUM_EXPENSES')}
        </Typography>
        <Box maxWidth='900px' sx={!dataExpense?.length ? { tr: { td: { textAlign: 'center' } } } : {}}>
          <UseStyled.ResponsiveReportTable>
            <TableCustom
              rowHeadCell={2}
              page={props.page}
              pageLimit={props.pageLimit}
              sortType={props.sortType}
              sortBy={props.sortBy}
              rowCount={props.rowCount}
              onSort={onRequestSort}
              setPageLimit={props.handleChangeRowsPerPage}
              setPage={props.handleChangePage}
              headCells={headCellsSub}
              rowsData={
                dataExpense?.length ? [
                  _.map(dataExpense, (d: any, index: number) => {
                    return renderDataIncomeExpense(d, index, 'data')
                  }),
                  renderDataIncomeExpense(dataExpense, 0, 'sum')
                ] : []}
              customScroll
              hidePagination
            />
          </UseStyled.ResponsiveReportTable>
        </Box>
      </Box>
    </>
  )
}

export default IncomeExpenseList
